import { GetkeywordSearchQnaQuery, QuestionAccessibleType } from '@/types/bff/gql-schema';
import { EQuestionAccessibleType, QuestionSearchResultVo } from '@/types/search';
import { SearchResult } from '@/types/search';
import { displayedAt, sortImageBlindTypeFormat } from '@/utils/format';
import { useGetkeywordSearchQnaQuery } from './search.gql.impl';

const KEYWORD_SEARCH_SIZE = 4;

const accessibleTypeEnumParser = (accessibleType: QuestionAccessibleType): EQuestionAccessibleType => {
  switch (accessibleType) {
    case QuestionAccessibleType.All:
      return EQuestionAccessibleType.All;
    case QuestionAccessibleType.DoctorsAndMe:
      return EQuestionAccessibleType.DoctorsAndMe;
    case QuestionAccessibleType.Me:
      return EQuestionAccessibleType.Me;
  }
};

const parseKeywordIntegratedSearchQnaVo = (data: GetkeywordSearchQnaQuery): SearchResult<QuestionSearchResultVo> => {
  return {
    hasMore: data.keywordSearchQuestionCardCursorPage.elements.length > 3,
    elements: data.keywordSearchQuestionCardCursorPage.elements.slice(0, 3).map((qna) => {
      return {
        ...qna,
        question: {
          ...qna.question,
          attachments: sortImageBlindTypeFormat(qna.question.attachments),
          accessibleType: accessibleTypeEnumParser(qna.question.accessibleType),
        },
        questionCreatedAt: displayedAt(qna.question.createdAt),
        answerCreatedAt: null,
      };
    }),
  };
};

const useGetKeywordIntegratedSearchQna = (keyword: string) => {
  const { data: keywordSearchQna, isLoading: isKeywordSearchQnaLoading } = useGetkeywordSearchQnaQuery(
    {
      request: {
        keyword,
        size: KEYWORD_SEARCH_SIZE,
      },
    },
    {
      select: parseKeywordIntegratedSearchQnaVo,
      enabled: keyword.length > 1,
    }
  );

  return {
    keywordSearchQna,
    isKeywordSearchQnaLoading,
  };
};

export default useGetKeywordIntegratedSearchQna;
